/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React from 'react';

/* APP E SERVIÇOS */

import { useAppContextoReact } from "../../servicos/app/AppContextoReact.tsx";

/* FORM E FIELDS */

import { Controller, useForm } from "react-hook-form";
import { Grid, Box, InputAdornment, InputLabel, Switch, Typography, FormControl, } from '@mui/material';
import TextField from '@mui/material/TextField';

/* INTERFACES E ENUMERAÇÕES */

import { User } from 'firebase/auth';
import { IRetornoAjaxUser } from '../../servicos/usuarios/Usuario_FrontAPI.ts';
import { IUserUpdate, bananinhaListError, validacao } from '../../servicos/IFormularios.ts';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha.tsx';
import AddEditComponent from '../../componentes/formularios/_AddEditComponent.tsx';
import {EFORM} from '../../componentes/formularios/EFORM.tsx';

/* ICONS */

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { isUndefined } from 'lodash';
import StyledStack from '../../../src/servicos/mui/StyledStack.tsx';

interface IPropsFormLightbox
{
	operacao: EFORM
	entidade: IUserUpdate
	setEntidade: (entidade: IUserUpdate) => void
	openDialog: boolean
	setOpenDialog: (openDialog: boolean) => void
	callBack: () => void
}

const FormDialog = (props:IPropsFormLightbox) =>
{
	const appContext = useAppContextoReact();
	const [user, setUser] = React.useState<User|null|undefined>(null);
	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);
	const [userPropsAdmin, setUserPropsAdmin] = React.useState<boolean|null|undefined>(null);
	const [bananinhaDelegate, setBananinhaDelegate] = React.useState<IBananinhaDelegate|undefined>(undefined);
	const [onSubmiting, setOnSubmiting] = React.useState<boolean>(false);
	const [open, setOpen] = React.useState(false);

	const { control, handleSubmit, reset, setError, setValue, formState: { errors } }
		= useForm<IUserUpdate>({reValidateMode: "onSubmit", criteriaMode: "all", shouldFocusError: false, defaultValues: props.entidade});

	const [inputPasswrd, setInputPasswrd] = React.useState<string>('');
	const [inputPasswrdConf, setInputPasswrdConf] = React.useState<string>('');
	const [showPassword, setShowPassword] = React.useState<boolean>(false);
	const [showPasswordConfirm, setShowPasswordConfirm] = React.useState<boolean>(false);
	const [password, setPassword] = React.useState<number>(0);
	const [passwordStrength, setPasswordStrength] = React.useState<string>('weak');

	React.useEffect(() =>
	{
		setUser(appContext?.usuario.user)
		setUserRolerAdmin(appContext.permissao.administrador)
	},[appContext])
	
	React.useEffect(() =>
	{ 
		reset(props.entidade);
		setUserPropsAdmin(props.entidade.customClaims ? props.entidade.customClaims.administrador : false)
	}, [props.entidade]);

	const handleSuccess = React.useCallback((msgSucesso: string) => 
	{
		setOnSubmiting(false);
		bananinhaDelegate?.abrir(msgSucesso ? msgSucesso : "Usuário " + (props.operacao == EFORM.ADD ? "criado" : "alterado") + " com sucesso.", "success");
	}, [bananinhaDelegate])
	const handleError = React.useCallback((combinedErrors: string) => 
	{
		setOnSubmiting(false);
		bananinhaDelegate?.abrir(combinedErrors, "error");
	}, [bananinhaDelegate])
	const onInvalid = (state: any) => 
	{
		let erroMsg = '<ul>';

        erroMsg += bananinhaListError(state);
        
        erroMsg += '<ul>';
        
        handleError(erroMsg)
	}
	async function onSubmit(data:IUserUpdate) 
	{
		setOnSubmiting(true);
		try
		{

			if (!userRoleAdmin) {
				throw new Error('Usuário não tem permissão para enviar o formulário.');
			}

			if (data.password != data.passwordConfirm)
			{
				let erro = "a confirmação está diferente da senha."
				setError("passwordConfirm", {type: "custom", message: erro})
				erro = "Confirmação da senha: " + erro;
				handleError(erro)
			}
			else
			{
				var res: IRetornoAjaxUser;
				if (props.operacao == EFORM.ADD) {
					res = await appContext?.usuario.userCreate(data.displayName, data.email, data.password, data.ehAdministrador ? data.ehAdministrador : false);
				} else {
					res = await appContext?.usuario.userUpdate(props.entidade.uid, data.email, data.displayName, data.password, data.ehAdministrador ? data.ehAdministrador : false);
				}
				if (res && (res.status == 200 || res.status == 201))
				{
					handleSuccess(res.message);
					setTimeout(() => {
						props.setOpenDialog(false);
						props.setEntidade(null);
					}, 5000);
					setOpen(false);
				}
				else {
					handleError(res.message);
				}
			}
		}
		catch(e)
		{
			handleError(e.message);
		}
		finally
		{
			setOnSubmiting(false);
			props.callBack();
		}
	}

	React.useEffect(() =>
	{
		if(props.openDialog)
			setOpen(true)
	},[props.openDialog])

	const handlePasswordTest = (value:string) =>
	{
		const newPassword = value;
		setPassword(newPassword.length)
		setInputPasswrd(newPassword)
		const strongRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
		if (strongRegex.test(newPassword) && newPassword.length >= 8)
		{
			setPasswordStrength('strong');
		}
		else
		{
			setPasswordStrength('weak');
		}
	}

	const handlePasswordChange = (event:any) => 
	{
		handlePasswordTest(event.target.value);
		setInputPasswrd(event.target.value);
	};

	function calcWidthPasswrdTest(total:number)
	{
		return (252 * Math.min(total, 16)) / 16;
	}
	
	return <>
		<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
		{user && props.entidade && 
			/* Seus outros elementos aqui ... */
			<AddEditComponent 
				ehDialog={true}
				tituloCaller={(props.operacao == EFORM.ADD ? "Adicionar" : "Editar") + " Usuário"}
				onSubmitingCaller={onSubmiting} 
				handleSubmitCaller={handleSubmit(onSubmit, onInvalid)}
				openCaller={open} 
				onCloseCaller={() => {
					setOpen(false);
					props.setOpenDialog(false);
					props.setEntidade(null);
				}} 
			>
            {/* Aqui, você pode adicionar todos os elementos que você quer renderizar dentro do CustomModal */}
				<Grid item xs={12} sm={6}>
					<Controller
						name="displayName"
						control={control}
						//	defaultValue={props.entidade.displayName}
						rules={{ 
							required: validacao.requerido, 
							// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
							maxLength: { value:100, message:`${validacao.maxLength} 100`, }
						}}
						render={({ field }) => (
							<TextField 
								{...field}
								label="Nome *" 
								fullWidth
								size="small"
								inputProps={{maxLength:100}}
								helperText={errors.displayName ? errors.displayName.message : null}
								error={!!errors.displayName}
								aria-invalid={!!errors.displayName}
							/>
						)}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<Controller
						name="email"
						control={control}
						//	defaultValue={props.entidade.email}
						rules={{ 
							required: props.operacao == EFORM.ADD ? validacao.requerido : '', 
							minLength: { value:7, message:`${validacao.minLength} 7`, },
							maxLength: { value:100, message:`${validacao.maxLength} 100`, },
							pattern: {
								value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
								message: "Formato de e-mail inválido."
							}
						}}
						render={({ field }) => (
							<TextField 
								{...field}
								label={props.operacao == EFORM.ADD ? "E-mail *" : "E-mail"}
								fullWidth
								size="small"
								inputProps={{maxLength:100}}
								helperText={errors.email ? errors.email.message : null}
								error={!!errors.email}
								aria-invalid={!!errors.email}
							/>
						)}
					/>
				</Grid>
                        
				<Grid item xs={12} sm={6}>
					<Controller
						name="password"
						control={control}
						defaultValue=""
						rules={{ 
							required: props.operacao == EFORM.ADD ? validacao.requerido : '', 
							minLength: { value:8, message:`${validacao.minLength} 8`, },
							maxLength: { value:16, message:`${validacao.maxLength} 16`, },
							pattern: {
								value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
								message: "Senha fraca ou caracteres inválidos. Utilize de 8 a 16 caracteres entre letras, números e os caracteres especiais @$!%*#?&"
							}
						}}
						render={({ field }) => (
							<TextField 
								{...field}
								label={props.operacao == EFORM.ADD ? "Senha *" : "Senha"}
								fullWidth
								size="small"
								inputProps={{maxLength:16}}
								helperText={errors.password ? errors.password.message : null}
								error={!!errors.password}
								aria-invalid={!!errors.password}
								autoComplete="new-password"
								type={showPassword ? 'text' : 'password'}
								onChange={(e) => {
									handlePasswordChange(e);
									setValue('password', e.target.value);
								}}
								InputProps={
								{
									endAdornment: (
										<InputAdornment position="end">
											{
											showPassword ? (
												<VisibilityIcon onClick={() => {setShowPassword(!showPassword)}} />
											) : (
												<VisibilityOffIcon onClick={() => {setShowPassword(!showPassword)}} />
											)}
										</InputAdornment>
									),
								}}
							/>
						)}
					/>
					<Box component={'div'} sx={{height: '5px', backgroundColor: "ButtonShadow", mt:1, mb:0, ml:1, mr:1 }}>
						<Box component={'div'} sx={{width: calcWidthPasswrdTest(password), height: '5px', backgroundColor: passwordStrength === 'weak' ? "red" : "green" }}></Box> 
					</Box>
				</Grid>

				<Grid item xs={12} sm={6}>
					<Controller
						name="passwordConfirm"
						control={control}
						defaultValue=""
						rules={{ 
							required: props.operacao == EFORM.ADD ? validacao.requerido : '', 
							minLength: { value:8, message:`${validacao.minLength} 8`, },
							maxLength: { value:16, message:`${validacao.maxLength} 16`, },
							pattern: {
								value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
								message: "Senha fraca. Utilize letras, números e caracteres especiais."
							}
						}}
						render={({ field }) => (
							<TextField 
								{...field}
								label={props.operacao == EFORM.ADD ? "Confirmação da senha *" : "Confirmação da senha"}
								fullWidth
								size="small"
								inputProps={{maxLength:16}}
								helperText={errors.passwordConfirm ? errors.passwordConfirm.message : null}
								error={!!errors.passwordConfirm}
								aria-invalid={!!errors.passwordConfirm}
								autoComplete="new-password"
								type={showPasswordConfirm ? 'text' : 'password'}
								onChange={(e) => {
									setInputPasswrdConf(e.target.value);
									setValue('passwordConfirm', e.target.value);
								}}
								InputProps={
								{
									endAdornment: (
										<InputAdornment position="end">
											{
											showPasswordConfirm ? (
												<VisibilityIcon onClick={() => {setShowPasswordConfirm(!showPasswordConfirm)}} />
											) : (
												<VisibilityOffIcon onClick={() => {setShowPasswordConfirm(!showPasswordConfirm)}} />
											)}
										</InputAdornment>
									),
								}}
							/>
						)}
					/>
				</Grid> 
				<Grid item xs={12} sm={6}>
				<FormControl fullWidth size="small">
					<Controller
						name="ehAdministrador"
						control={control}
						render={({ field }) => (
							<StyledStack direction="row" spacing={1}>
								<InputLabel shrink>Administrador ?</InputLabel>
								<Typography className='semDestaque'>Não</Typography>
								<Switch
									{...field}
									disabled={!userRoleAdmin ? true : false}									
									size='small'
									defaultChecked={userPropsAdmin ? true : false}
								/>
								<Typography>Sim</Typography>
							</StyledStack>
						)}
					/>
				</FormControl>
				</Grid>
				{/* ... e assim por diante */}
			</AddEditComponent>
			/* Outros elementos que você quiser ... */
		}
	</>
}
export default FormDialog;
